<template>
  <div ref="marqueeBox" class="marquee-box">
    <div class="marquee-con">
      <div ref="marqueeCopy" class="marquee-1">
      </div>
      <div ref="marquee" class="d-flex justify-content-between">
        <div href="" v-for="item in list" :key="item.id" @click="toArticleDetail(item.id)"><img :src="item.path" class="marquee-img" alt="" srcset=""></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Marquee',
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      // 跑马灯 start
      var marqueeBox = this.$refs.marqueeBox
      var marquee = this.$refs.marquee
      var marqueeCopy = this.$refs.marqueeCopy
      // marqueeCopy.innerHTML = marquee.innerHTML;
      // console.log(marquee.innerHTML);
      function fun () {
        // 从右向左
        if (marqueeBox.scrollLeft >= 400) {
          marqueeBox.scrollLeft = 0
        } else {
          marqueeBox.scrollLeft++
        }
      }
      var timer = setInterval(fun, 50)
      marqueeBox.onmouseover = function () {
        // 鼠标经过时  清除定时器  停止图片的滚动
        clearInterval(timer)
      }
      marqueeBox.onmouseout = function () {
        // 鼠标离开后  继续滚动图片
        timer = setInterval(fun, 50)
      }
      // 跑马灯 end
    },
    toArticleDetail(id) {
      let {href} = this.$router.resolve({path: `/a-detail?id=${id}`})
      window.open(href, '_blank')
    },
  }
}
</script>

<style lang='less' scoped>
// 跑马灯
.marquee-box, .marquee-box1{
	width:980px;
  margin: 0 auto;
	overflow: hidden;
	height:132px;
}
.marquee-con, .marquee-con1{
	width:500%;
	float:left;
}
.marquee,.marquee-1, .marquee1,.marquee-2{
	float:left;
}
.marquee-img{
	float:left;
	height:232px;
  width: 186px;
  object-fit: cover;
	margin-left:16px;
  cursor: pointer;
}
</style>
